<template>
  <div class="pc-list" ref="list">
    <Search @search="search" ref="reSearch"/>

    <div class="pc-list-head">
      <!-- <el-checkbox v-model="isSelectAll" @change="selectAll">全选</el-checkbox> -->
      <!-- <el-checkbox v-model="isSelectAll">全选&nbsp;&nbsp;{{ '(已选' + selectCount + '个)' }}</el-checkbox> -->
      <div class="pc-list-head-handle">
        <div class="pc-list-head-btn">
          <button @click="deleteRegion">删除</button>
          <span></span>
          <button @click="addRegion">添加</button>
          <span></span>
          <button @click="exportRegion">导出数据</button>
        </div>
        <p>{{ "共" + dataArgs.total + "条" }}</p>
      </div>
    </div>

    <el-table class="pc-list-table" :data="regionList" @sort-change="changeSort">
      <el-table-column width="140" fixed="left">
        <template slot="header" slot-scope="header">
          <el-checkbox v-model="isSelectAll" @change="selectAll">{{
            "已选" + checked.length + "个"
          }}</el-checkbox>
        </template>
        <template slot-scope="scope" >
          <el-checkbox
            v-model="scope.row.isSelect"
            @change="
              singleCheck(
                scope.$index,
                scope.row.isSelect,
                scope.row.id,
                scope.row
              )
            "
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
      fixed="left"
        prop="id"
        label="ID"
        sortable="custom" 
        width="140"
      ></el-table-column>
      <el-table-column prop="name" label="名称" width="200" fixed="left"></el-table-column>
      <el-table-column label="封面图" width="170">
        <template slot-scope="scope">
          <div v-if="scope.row.bgImage" class="eltable-img">
            <img :src="scope.row.bgImage" />
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="标签" width="230">
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.tags" :key="index">
            {{ item.name }}
          </div>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="collectNums"
        label="收藏人数"
        sortable="custom" 
        width="120"
      ></el-table-column>
      <el-table-column
        prop="position"
        label="位置"
        width="150"
      ></el-table-column>
      <el-table-column prop="tags" label="标签" width="170"></el-table-column>

      <el-table-column label="数据更新时间" sortable="custom" prop="updateTime" width="180">
        <template slot-scope="scope">
          <div>{{ $dtime(scope.row.createTime).format("YYYY-MM-DD") }}</div>
        </template>
      </el-table-column>

      <el-table-column label="状态" width="120" sortable="custom" prop="status">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#91CC75"
            inactive-color="#C7C7C7"
            @change="changeStatus(scope.row)"
            :class="{
              'switch-is-active': scope.row.status,
              'switch-is-not-active': !scope.row.status,
            }"
          >
          </el-switch>
        </template>
      </el-table-column>

      <el-table-column width="120">
        <template slot-scope="scope">
          <button class="btnViewDetail" @click="viewDetail(scope.row)">
            查看详情
          </button>
        </template>
      </el-table-column>
    </el-table>

    <Pagination
      v-if="regionList.length > 0"
      class="pagination"
      :pagination="dataArgs"
      @goPage="goPage"
      @handleCurrentChange="goPage"
      @goLastPage="goPage"
      @goFirstPage="goPage"
    />
    <ExportTable
      :tableData="selectedItems"
      :exportFeild="exportFeild"
      ref="exportTable"
    />
    <DeleteHint
      :dialogVisible="deleteDialogVisible"
      @cancel="closeDelete"
      @delete="isDelete"
      :moduleName="'城市群'"
      :subName="'城市'"
    />

  </div>
</template>



<script>
import DeleteHint from "../../../template/DeleteHint.vue";
import Pagination from "../../../template/Pagination";
import ExportTable from "../../../template/exportTable.vue";
import Search from "./Search";
import { getCityGroups, deleteCityGroups, updateCityGroupStatus } from "./regionList.gql";

export default {
  components: {
    Search,
    DeleteHint,
    ExportTable,
    Pagination,
  },
  watch: {},
  data() {
    return {
      deleteDialogVisible: false,
      isSelectAll: false,
      dataArgs: {
        keywords: null,
        take: 10,
        skip: 0,
        order: "-updateTime",
        type: null,
        status: -1,
        name: null,
        continent: null,
        country: null,
      },
      regionList: [],
      checked: [],
      selectedItems: [],
      exportFeild: [
        { label: "ID", prop: "id" },
        { label: "名称", prop: "name" },
        { label:'英文名',prop:'englishName'},
        { label:'所属大洲',prop:'continent'},
        { label:'所属国家',prop:'country'},
        { label:'经度',prop:'lng'},
        { label:'纬度',prop:'lat'},
        { label:'英文简介',prop:'englishIntro'},
        { label:'中文简介',prop:'intro'},
        { label: "封面图", prop: "bgImage" },
        { label: "收藏人数", prop: "collectNums" },
        { label: "浏览人数", prop: "nums" },
        { label: "城市数", prop: "cityNums" },
        { label: "标签", prop: "tags" },
        { label: "数据更新时间", prop: "updateTime1" },
        { label: "数据录入时间", prop: "createTime1" },
        { label: "面积", prop: "area" },
        { label: "人口", prop: "population" },
        { label: "GDP", prop: "gdp" },
        { label: "状态", prop: "status1" },
      ],
    };
  },
  created() {
    this.routerAwardsTable();
  },
  mounted() {
    this.getRegions();
  },
  methods: {
    changeSort(val){
      if(val.order=='ascending'){
        this.dataArgs.order = "+" + val.prop
      }
      if(val.order=='descending'){
        this.dataArgs.order = "-" + val.prop
      }
      if(val.order==null){
        this.dataArgs.order = '-updateTime'
      }
      this.dataArgs.skip = 0
      this.getRegions()
    },
    changeStatus(val){
      let status = 0
      if(val.status==true){
        status = "1"
      }else{
         status = "0"
      }
      this.$global
          .GraphqlMutation(this, updateCityGroupStatus, {status: status, id: val.id})
          .then((res) => {
            this.$global.success(this, "操作成功");
            // this.getCities(this.cityArgs);
          });

    },
    // 判断路由查看是否需要根据奖项查询Table
    routerAwardsTable() {
   
      if (this.$route.path == "/admin/awardslist") {
        this.dataArgs.keywords = this.$route.query.name;
      } else {
        console.log("列表页");
      }
    },
    getRegions() {
      this.$global
        .GraphqlQuery(this, getCityGroups, this.dataArgs)
        .then((res) => {
          this.checked = [];
          this.$set(this.dataArgs, 'total', res.total )
          for (let i = 0; res.data.length > i; i++) {
            res.data[i].isSelect = false;
            res.data[i].position =
              res.data[i].country + "," + res.data[i].continent;
            let tags = "";
            res.data[i].tags.forEach((item, index) => {
              if (index < 3) {
                tags += item.name + ",";
              }
            });
            if(res.data[i].collectNums == null ){
              res.data[i].collectNums = 0
            }
            res.data[i].tags = tags.substr(0, tags.length - 2);
            if (res.data[i].status == "1") {
              res.data[i].status = true;
            } else {
              res.data[i].status = false;
            }
            res.data[i].basicData.forEach((item)=>{
              if(item.name=='Area'){
                res.data[i].area = item.value;
              }
               if(item.name=='Population'){
                res.data[i].population = item.value;
              }
               if(item.name=='GDP'){
                res.data[i].gdp = item.value;
              }
            })
            res.data[i].updateTime1 = this.$dtime(res.data[i].updateTime).format("YYYY-MM-DD HH:MM:SS")
            res.data[i].createTime1 = this.$dtime(res.data[i].createTime).format("YYYY-MM-DD HH:MM:SS")
            // res.data[i].status = res.data[i].status == "1" ? true : false;
          }
          this.regionList = res.data;
          // this.tabName = '1'
          // this.removeTag();
        });
    },

    viewDetail(item) {

      let route = this.$router.resolve({
        path: "/admin/regionDetail",
        query: { id: item.id },
        name: "regionDetail",
        params: item,
      });
      window.open(route.href, "_blank");
      //  window.open(href, '_blank')
    },

    // 全选按钮
    selectAll() {
      if (this.isSelectAll) {
        this.checked = [];
        this.selectedItems = [];
        this.regionList.forEach((item, i, arr) => {
          this.$set(item, "isSelect", true);
          this.checked.push(item.id);
          if (item.status == true) {
            item.status1 = "有效";
          } else {
            item.status1 = "失效";
          }
          this.selectedItems.push(item);
        });
      } else {
        this.regionList.forEach((item, i, arr) => {
          item.isSelect = false;
          this.checked = [];
          this.selectedItems = [];
          if (item.status == true) {
            item.status1 = "有效";
          } else {
            item.status1 = "失效";
          }
        });
      }
    },
    // 单选按钮
    singleCheck(index, isSelect, rowID, row) {
      if (isSelect == false) {
        this.isSelectAll = false;
        for (let i = 0; this.checked.length > i; i++) {
          if (this.checked[i] == rowID) {
            this.checked.splice(i, 1);
            this.selectedItems.splice(i, 1);
            return;
          }
        }
      } else {
        this.checked.push(rowID);
        if (row.status == true) {
          row.status1 = "有效";
        } else {
          row.status1 = "失效";
        }
        this.selectedItems.push(row);
        if (this.checked.length == 10) {
          this.isSelectAll = true;
        }
      }
    },
    search(val) {
      // 计算keyworlds
      this.dataArgs.name = val.name;
      this.dataArgs.country = val.country;
      this.dataArgs.continent = val.continent;
      this.dataArgs.skip = 0
      if (val.keywords) {
        this.dataArgs.keywords = val.keywords[1];
      }

      //   this.dataArgs = {
      //   keywords:val.keywords,
      //   title:val.title,
      //   take: 10,
      //   skip: 0,
      //   total:0,
      //   order: "-updateTime",
      //   type: null,
      //   status: -1,
      // }
      //   console.log("123", val,this.dataArgs);
      this.getRegions();
    },
    // 删除
    deleteRegion() {
      this.deleteDialogVisible = true;
    },
    // 添加
    addRegion() {
     let route = this.$router.resolve({
        path: "/admin/regionDetail",
        name: "regionDetail",
      });
      window.open(route.href, "_blank");
    },
    // 导出数据
    exportRegion() {
      this.$refs.exportTable.exports();
    },

    goPage(data) {
      this.dataArgs.skip = (data - 1) * 10;
      this.getPractices();
      window.scrollTo(0, this.$refs.list.offsetTop + 210);
    },
    // 需要回调 
    neeedReSearch(){
      this.$refs.reSearch.getTagTypes()
    },
    isDelete() {
      let data = { ids: this.checked };
      // for (let i = 0; this.checked.length > i; i++) {
      this.$global
        .GraphqlMutation(this, deleteCityGroups, {
          // Parameters
          data: data,
        })
        .then((res) => {
          this.getRegions();
          this.deleteDialogVisible = false;
        });
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
  },
};
</script>


<style lang="scss" scoped>
.pc-list {
  margin-top: 40px;
  padding: 60px 20px 55px 40px;
  border-radius: 4px;
  box-shadow: $shadowCard;
  .pc-list-head {
    margin-top: 40px;
    border-top: 1px solid #c0c0c0;
    padding-top: 35px;
    margin-bottom: 35px;
    letter-spacing: 1px;
    font-family: $chinese;
    font-size: 14px;
    color: $mainTitle;
    .pc-list-head-handle {
      // float: right;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-bottom: 20px;
      .pc-list-head-btn {
        display: flex;
        border: 1px solid $schoolTagBorder;
        margin-right: 30px;
        border-radius: 4px;
        button,
        p {
          cursor: pointer;
          font-family: $chinese;
          font-size: 14px;
          color: $mainTitle;
          letter-spacing: 1px;
        }

        button {
          width: 100px;
          // height: 30px;
          background: none;
          outline: none;
          padding: 10px 0px;
          box-sizing: content-box;
          border: none;
        }
        span {
          height: 16px;
          border: 1px solid $schoolTagBorder;
          align-self: center;
        }
        // button:nth-of-type(1){
        //   border-right: 0;
        // }
        // button:nth-of-type(2){
        //   border-right: 0;
        //   border-left: 0;
        // }
        // button:nth-of-type(3){
        //   border-left: 0;

        // }
        button:hover {
          background: $blueBtn;
          color: white;
        }
        // button:first-child {
        //   border-top-left-radius: 4px;
        //   border-bottom-left-radius: 4px;
        // }
        // button:nth-last-of-type(1) {
        //   border-left: none;
        //   border-top-right-radius: 4px;
        //   border-bottom-right-radius: 4px;
        // }
        p {
          margin-left: 32px;
        }
      }
    }
  }

  .pc-list-table {
    overflow: visible !important;
    .eltable-img {
      img {
        height: 50px;
        // width:100px;
        object-fit: cover;
      }
    }
    .btnViewDetail {
      width: 90px;
      height: 30px;
      border-radius: 4px;
      border: 1px solid $timeBtn;
      outline: none;
      background: none;
      font-family: $chinese;
      font-size: 12px;
      color: $timeBtn;
      cursor: pointer;
    }
    .btnViewDetail:hover {
      background: $blueBtn;
      color: white;
    }
    /deep/ .el-table__body-wrapper {
      min-height: 500px;
    }
     /deep/ .cell {
        text-align: center !important;
        font-family: $chinese !important;
        font-size: 14px !important;
        color:$thirdTitle;
      }
      /deep/ .el-table__row{
         .cell{
          color:$mainTitle !important;
        }
      }
      /deep/ .is-leaf {
        background: $base-color !important;
        font-weight: normal !important;
      }
    /deep/ .el-switch__core {
      width: 54px !important;
      height: 20px !important;
      display: flex;
      align-items: center;
    }
    .switch-is-active {
      /deep/ .el-switch__core {
        &::before {
          content: "有效";
          font-size: 8px;
          color: white;
          padding-left: 6px;
        }
      }
    }
    .switch-is-not-active {
      /deep/ .el-switch__core {
        &::before {
          content: "无效";
          font-size: 8px;
          color: white;
          padding-left: 22px;
        }
      }
    }
  }

  .pagination {
    margin-top: 45px;
  }
  /deep/ .pc-pagin {
    justify-content: flex-end !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/map/regionList/regionTable.vue